var e={NotDefined:"Undefined",Installed:"Installed",Removed:"Removed"},a={Installation:"Install",Removal:"Remove",Check:"Check"};export{a as SealAction,e as SealsStatus};
//# sourceMappingURL=types.js.map